import { gql } from '@apollo/client'

export const LOCATIONS_TREE_QUERY = gql`
  query LOCATIONS_TREE_QUERY($pagination: PaginationInput, $filter: LocationFilterInput) {
    locations(pagination: $pagination, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        code
        active
        expanded
        parentId
        description
        createdAt
        position
        geoLocation {
          address
          state
          city
          country
          latitude
          longitude
        }
        parent {
          id
          description
        }
        integrations {
          provider
          externalId
          syncedAt
        }
      }
    }
  }
`

export const LOCATIONS_SELECT_QUERY = gql`
  query LOCATIONS_SELECT_QUERY($filter: LocationFilterInput) {
    locations(filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        active
        description
        parent {
          id
          description
        }
      }
    }
  }
`
